import { render, staticRenderFns } from "./CategoriaDocumentos.vue?vue&type=template&id=093cc5c8&scoped=true&"
import script from "./categoriaDocumentos.ts?vue&type=script&lang=ts&"
export * from "./categoriaDocumentos.ts?vue&type=script&lang=ts&"
import style0 from "./CategoriaDocumentos.vue?vue&type=style&index=0&id=093cc5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093cc5c8",
  null
  
)

export default component.exports